import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=bbc4bd7c&scoped=true"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=bbc4bd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4bd7c",
  null
  
)

export default component.exports